import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
export function useNavigationState() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");
  const { pathname, hash } = useLocation();
  const toggle = useRef<HTMLButtonElement>(null);
  const progress = useRef<HTMLDivElement>(null);
  useEffect(() => setOpen(false), [pathname, hash]);
  useEffect(() => {
    function close(e: KeyboardEvent) {
      if (e.key === "Escape" && open) {
        setOpen(false);
        toggle.current?.focus();
      }
    }
    document.addEventListener("keydown", close);
    return () => document.removeEventListener("keydown", close);
  }, [open]);
  useEffect(() => {
    let raf = 0;
    function update() {
      const max = document.documentElement.scrollHeight - innerHeight;
      progress.current?.style.setProperty(
        "transform",
        `scaleX(${max > 0 ? scrollY / max : 0})`,
      );
      const sections = ["work", "about", "experience", "contact"];
      let current = "";
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top < innerHeight * 0.4)
          current = id;
      }
      setActive(pathname.startsWith("/work/") ? "work" : current);
      raf = 0;
    }
    function onScroll() {
      if (!raf) raf = requestAnimationFrame(update);
    }
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [pathname]);
  return { open, setOpen, active, toggle, progress };
}
